module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external "xmldom"
// module id = 42
// module chunks = 0